import { Body, Heading, VisuallyHide } from '@superhi/design'
import React from 'react'

import {
  Row,
  RowHeading,
  RowCells,
  RowCell,
  Wrapper,
  ColumnHeaders,
  RowHeaderSpacer,
  ColumnHeaderCell,
  SmallPrintRow,
} from './styles'

type TableRowCell = string | React.ReactElement

type TableRow = {
  heading?: string
  cells: TableRowCell[]
}

type TableColumn = {
  heading: string
}

type Props = {
  columns: TableColumn[]
  rows: TableRow[]
  smallPrint?: string
}

const Table: React.FC<React.PropsWithChildren<Props>> = ({ rows, columns, smallPrint }) => {
  const rowsHaveHeaders = rows.some((row) => !!row.heading)
  const numColumns = columns.length

  return (
    <Wrapper $numColumns={numColumns}>
      <ColumnHeaders>
        {rowsHaveHeaders && <RowHeaderSpacer> </RowHeaderSpacer>}
        {columns.map((column, columnIndex) => (
          <ColumnHeaderCell key={columnIndex} aria-hidden="true">
            <Heading level="4" as="h3">
              {column.heading}
            </Heading>
          </ColumnHeaderCell>
        ))}
      </ColumnHeaders>
      {rows.map((row, rowIndex) => (
        <Row key={rowIndex}>
          {row.heading && (
            <RowHeading>
              <Heading level="6" asLevel="3">
                {row.heading}
              </Heading>
            </RowHeading>
          )}
          <RowCells>
            {row.cells.map((rowCell, rowCellIndex) => (
              <RowCell key={rowCellIndex}>
                <VisuallyHide>{columns[rowCellIndex].heading}: </VisuallyHide>
                {typeof rowCell === 'string' ? <Body level="3">{rowCell}</Body> : rowCell}
              </RowCell>
            ))}
          </RowCells>
        </Row>
      ))}
      {smallPrint && (
        <SmallPrintRow>
          <RowCells>
            <RowCell>
              <Body level="3" color="GREY_70">
                {smallPrint}
              </Body>
            </RowCell>
          </RowCells>
        </SmallPrintRow>
      )}
    </Wrapper>
  )
}

export default Table
